import { render, staticRenderFns } from "./DsGeneralListModal.vue?vue&type=template&id=1cca56b8"
import script from "./DsGeneralListModal.vue?vue&type=script&lang=js"
export * from "./DsGeneralListModal.vue?vue&type=script&lang=js"
import style0 from "./DsGeneralListModal.vue?vue&type=style&index=0&id=1cca56b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports